
<button 
  class="point-actions__button point-actions__button--third"
  [attr.aria-label]="'Eliminar recurso' | translate"
  (click)="handleDeletePointClick()"
>
  <ci-icon
    class="point-actions__icon"
    name="btn-delete"
    type="svg"
  ></ci-icon>
  
  <span class="point-actions__text ci-footer-regular">
    {{ 'Eliminar recurso' | translate }}
  </span>
</button>